const esJSON = {
  DUPLICATE_OF: 'Duplicado de',
  DUPLICATED_BY: 'Duplicado por',
  RELATED_TO: 'Relacionado a',
  SPLIT_TO: 'Derivado de',
  SPLIT_FROM: 'Derivado por',
  BLOCKED_BY: 'Bloqueado por',
  BLOCKS: 'Bloques',
  MORE_THAN: 'Mayor que',
  LESS_THAN: 'Menor que',
  OPEN: 'Abierta',
  IN_PROGRESS: 'En progreso',
  ON_HOLD: 'En espera',
  COMPLETE: 'Completa',
  'home.built': 'Diseñado para facilitar la gestión del mantenimiento',
  home_description:
    'Cuando las pizarras y las notas adhesivas son un caos y necesitas un CMMS que sea fácil de usar por tu equipo, prueba {{shortBrandName}} ',
  try_grash: 'Prueba {{shortBrandName}}',
  login: 'Iniciar sesión',
  start_trial: 'Comienza una prueba gratis',
  'home.what': 'Que',
  'home.you_will_have': 'Tendrás',
  'home.you_will_have_description':
    'Cree flujos de trabajo eficientes y confiables que le permitan controlar el mantenimiento. Genere, asigne y realice un seguimiento de órdenes de trabajo. Controlar el inventario. Y obtenga informes automatizados confiables que mejoren la visibilidad y generen responsabilidad.',
  key_features: 'Características clave',
  key_features_description:
    'Algunas de las características que hacen de {{shortBrandName}} uno de los mejores CMMS disponibles en la actualidad',
  contribute: 'Contribuir',
  work_orders: 'Órdenes de trabajo',
  request_system: 'Sistema de solicitud de trabajo',
  mobile_app: 'Aplicación móvil',
  asset_management: 'Gestión de activos',
  preventive_maintenance: 'Mantenimiento preventivo',
  parts_inventory: 'Inventario',
  custom_dashboards: 'Tableros personalizados',
  'work-orders.title': 'Administra tus órdenes de trabajo como un profesional',
  'work-orders.description.short': 'Visualiza y gestiona todas tus tareas',
  'work-orders.descriptions.0':
    '¿Está cansado de la gran cantidad de papeles y de las órdenes de trabajo perdidas? Todo esto afecta directamente la obtención de resultados y su reputación.',
  'work-orders.descriptions.1':
    'Con {{shortBrandName}} puede organizar fácil y rápidamente todas sus órdenes de trabajo, el mantenimiento preventivo y otras tareas de su equipo en una base de datos centralizada a la que se puede acceder desde cualquier lugar y cualquier dispositivo.',
  'work-orders.checks.0':
    'Ver todas sus tareas, incluidas las órdenes y solicitudes de trabajo y el mantenimiento preventivo',
  'work-orders.checks.1':
    'Establecer prioridades a sus tareas para que el trabajo más importante se realice primero.',
  'work-orders.checks.2': 'Ver un calendario de tareas presentes y futuras.',
  'work-orders.checks.3':
    'Vea órdenes de trabajo con información crítica, como detalles de activos, fecha de vencimiento, prioridad y más.',
  'work-orders.checks.4':
    'Vea indicadores críticos, como el trabajo completado, el tiempo invertido y el trabajo planificado frente al no planificado..',
  'work-requests.title':
    'Una plataforma móvil optimizada que permite realizar solicitudes de trabajo',
  'work-requests.descriptions.0':
    '¿Está cansado de usar el antiguo sistema de teléfono y correos electrónicos que resulta en solicitudes PERDIDAS, constantes interrupciones diarias y trabajo duplicado?',
  'work-requests.descriptions.1':
    'La de gestión de mantenimiento a través de {{shortBrandName}} permite a cualquier persona que esté autorizada a enviar un problema a su departamento de mantenimiento simplemente escaneando un código QR o visitando una URL y escribiendo su solicitud a través de sus dispositivos móviles.',
  'work-requests.checks.0': 'Nunca pierdas un trabajo de nuevo.',
  'work-requests.checks.1':
    'Reduzca el tiempo dedicado a gestionar solicitudes de trabajo hasta en un 34 %.',
  'work-requests.checks.2':
    'Reduzca el tiempo de comunicación con quiénes soliciten una tarea hasta en un 41% (llamadas, correos electrónicos, mensajes de texto).',
  'mobile-app.title':
    'Una aplicación CMMS móvil que jerarquiza a su equipo de mantenimiento',
  'mobile-app.descriptions.0':
    'Mediante el uso de nuestras aplicaciones móviles Android e IOS, nuestros clientes experimentan una mejor organización, comunicación, responsabilidad y productividad hasta en un 30% en todo su equipo de mantenimiento.',
  'mobile-app.descriptions.1':
    'Desde su dispositivo móvil, cualquier miembro de su equipo de mantenimiento puede:',
  'mobile-app.checks.0': 'Ver sus órdenes de trabajo y MP asignados.',
  'mobile-app.checks.1':
    'Registrar sus órdenes de trabajo en menos de 60 segundos',
  'mobile-app.checks.2':
    'Recibir comunicaciones instantáneas a través de notificaciones y correos electrónicos.',
  'mobile-app.checks.3':
    'Iniciar nuevas órdenes de trabajo mientras te encuentres en el campo.',
  'mobile-app.checks.4':
    'Responder y registrar problemas mientras te encuentres trabajando en ello',
  'mobile-app.checks.5':
    'Buscar información crítica sobre sus activos mientras diagnostica un fallo.',
  'eam.title': 'Gestión de activos empresariales',
  'eam.description.short': 'Conozca sus activos',
  'eam.descriptions.0':
    '¿Frustrado por tratar de organizar el desorden de los equipos de la empresa, preguntándose si los equipos han sido cuidados adecuadamente, sin saber cuánto cuesta su mantenimiento y todos los demás dolores de cabeza que conlleva la gestión de activos?',
  'eam.descriptions.1':
    'El software para la gestión de activos empresariales {{brandName}} se puede utilizar para entre 10 y 1.000.000 de activos, lo que le permite realizar un seguimiento exactamente de lo que desea, de la manera que desee, en una estructura de árbol fácil de usar y con capacidad de búsqueda.',
  'eam.checks.0':
    'Conozca el estado de sus activos en cada momento y lo que le están costando',
  'eam.checks.1': 'Vea registros de mantenimiento completos y detallados.',
  'eam.checks.2':
    'Realice un seguimiento solo de lo que desee con campos personalizados ilimitados',
  'eam.checks.3': 'Organice sus activos en una jerarquía clara.',
  'eam.checks.4':
    'Encuentre información rápido y fácil gracias a los códigos QR (código de barras)',
  'eam.checks.5':
    'Reciba datos de activos en tiempo real con conectividad de sensores.',
  'pm.title': 'Un programa de mantenimiento preventivo eficaz',
  'pm.descriptions.0':
    'Deje de perder horas preciosas distribuyendo manualmente listas de verificación de MP y haciendo un seguimiento con su equipo para asegurarse de que el trabajo esté terminado.',
  'pm.descriptions.1':
    '{{shortBrandName}} le permite automatizar fácilmente la programación de MP para que el trabajo correcto se entregue automáticamente en el momento adecuado al técnico adecuado para el activo adecuado.',
  'pm.checks.0':
    'Automatice la programación de MP para que sea diaria, semanal, mensual, anual o basada en eventos o lecturas de medidores.',
  'pm.checks.1':
    'Notificaciones automáticas y por correo electrónico cuando se crea o vence una orden de MP.',
  'pm.checks.2':
    'Nuestro Calendario fácil de usar le permite ver todos los trabajos abiertos y los próximos MP.',
  'pm.checks.3': 'Arrastre y suelte para cambiar la fecha de vencimiento.',
  'pm.checks.4':
    'Al finalizar el MP, el trabajo se registra automáticamente en el registro de mantenimiento del activo.',
  'pm.checks.5': 'Requiere poca o ninguna formación para su uso.',
  'part.title': 'Obtenga el control de su inventario de repuestos',
  'part.description.short': 'Sepa cuándo se acabarán sus repuestos',
  'part.descriptions.0':
    '¿No está seguro de qué repuestos tiene en stock o dónde se utilizan? ¿No sabes cuándo se acabarán tus repuestos o si tus técnicos tendrán los repuestos necesarios para hacer su trabajo?',
  'part.descriptions.1':
    'Diseñamos la gestión de repuestos de {{shortBrandName}} para resolver esos problemas y más:',
  'part.checks.0':
    'Reciba notificaciones instantáneas y por correo electrónico cuando la cantidad de un repuesto sea baja. Mantenga la cantidad correcta de repuestos en stock recibiendo notificaciones automáticas e instantáneas por correo electrónico cuando la cantidad esté por debajo de un umbral establecido.',
  'part.checks.1':
    'Los técnicos saben instantáneamente si un repuesto está en stock desde una Orden de Trabajo. Si el repuesto no está en stock, consulte fácilmente otras ubicaciones para ver si está disponible.',
  'part.checks.2':
    'Seguimiento automático del uso de repuestos. A medida que las órdenes de trabajo o los MP utilicen repuestos, el inventario se actualizará automáticamente para reflejar los repuestos utilizados.',
  'part.checks.3':
    'Conozca el uso de un repuesto. Vea el registro de repuestos para ver dónde se utilizó y quién lo utilizó',
  'part.checks.4':
    'Eliminar los repuestos no utilizados. Sepa cuando un repuesto se ha quedado obsoleto.',
  'part.checks.5':
    'Informes en tiempo real. Sepa qué repuestos se utilizan, dónde y cuánto le cuestan.',
  'part.checks.6':
    'Optimizar los niveles de stock. Vea instantáneamente el pronóstico de uso de un repuesto para ver cuántos se pueden usar durante el próximo año.',
  'part.checks.7':
    'Búsqueda a través de códigos de barra. Haga que su inventario sea fácil de rastrear y acceder con códigos QR personalizados',
  'dashboard.title':
    'Tus datos a tu manera, gracias a la implementación de tableros presonalizados',
  'dashboard.descriptions.0':
    'Seamos realistas, el primer paso para mejorar tus operaciones es conocer lo bueno, lo malo y lo feo.',
  'dashboard.descriptions.1':
    'Con los tableros personalizados de {{shortBrandName}}, finalmente puede comenzar a comprender ese infame "agujero negro del mantenimiento" y comenzar a poner en práctica planes respaldados por datos, lo que resulta en menores costos laborales, menor tiempo de inactividad y más.',
  'dashboard.descriptions.2':
    'Con los tableros personalizados de {{shortBrandName}} podrá...',
  'dashboard.checks.0': 'Sepa dónde se gasta su dinero y en qué',
  'dashboard.checks.1': 'Sepa qué activo cuesta más y por qué',
  'dashboard.checks.2': 'Cree indicadores personalizados.',
  'dashboard.checks.3':
    'Vea informes que se generan y actualizan automáticamente según sus mediciones',
  'dashboard.checks.4':
    'Vea informes que se pueden compartir fácilmente a través de hojas de Excel, PDF o dentro de {{shortBrandName}}',
  'dashboard.checks.5': 'Y mucho más...',
  'home.smarter': 'Más inteligente',
  'home.work': 'Trabajo',
  'home.smarter_description':
    '{{shortBrandName}} hace que sea increíblemente fácil para los técnicos trabajar de manera eficiente al brindarles acceso a las herramientas y los datos que necesitan para realizar el trabajo, todo desde la palma de su mano.',
  leading_maintenance:
    'Liderando el camino hacia un futuro mejor para el mantenimiento y la confiabilidad',
  premium_included: 'Funciones premium incluidas',
  no_credit_card: 'No se requiere tarjeta de crédito',
  perfect_tool: 'La herramienta perfecta para los equipos de mantenimiento',
  start_trial_today: 'Comience su prueba gratuita hoy',
  create_account: 'Crear cuenta',
  signup_description:
    'Complete los campos a continuación para registrarse y obtener una cuenta.',
  account_already: 'Ya tiene una cuenta?',
  signin_here: 'Inicie sesión aquí',
  invalid_email:
    'El correo electrónico proporcionado debe ser una dirección de correo electrónico válida.',
  required_email: 'El correo electrónico es obligatorio.',
  required_firstName: 'El nombre es obligatorio.',
  required_lastName: 'El apellido es obligatorio.',
  required_company: 'El nombre de la Empresa es obligatorio.',
  required_employeesCount: 'Por favor, proporcione el número de empleados.',
  invalid_phone: 'El número de teléfono no es válido.',
  required_password: 'El campo de contraseña es obligatorio',
  required_terms: 'Debes aceptar nuestros términos y condiciones.',
  verify_email:
    'Por favor revise su correo electrónico para activar su cuenta.',
  registration_error: 'El registro falló',
  first_name: 'Nombre',
  last_name: 'Apellido',
  email: 'Correo electrónico',
  phone: 'Teléfono',
  password: 'Contraseña',
  companyName: 'Nombre de la Empresa',
  employeesCount: 'Número de empleados',
  i_accept: 'Acepto los',
  terms_conditions: 'términos y condiciones',
  create_your_account: 'Crear cuenta',
  register: 'Registrarse',
  login_description:
    'Complete los datos a continuación para iniciar sesión con su cuenta.',
  no_account_yet: '¿Todavía no tienes una cuenta?',
  signup_here: 'Registrate aquí',
  wrong_credentials: 'Los datos proporcionados son incorrectos',
  lost_password: '¿Olvido su contraseña?',
  link_wo: 'Vincular Órdenes de Trabajo',
  link_wo_description: 'Crear relaciones entre Órdenes de Trabajo',
  required_relationType: 'Por favor seleccione el tipo de relación.',
  required_wo: 'El campo Orden de trabajo es obligatorio.',
  this_wo: 'Esta orden de trabajo',
  the_wo: 'La orden de trabajo',
  link: 'Vincular',
  cost_description: 'Descripción del costo',
  assigned_to: 'Asignado a',
  category: 'Categoría',
  date: 'Fecha',
  cost: 'Costo',
  include_cost: 'Incluir este costo en el costo total.',
  include_cost_description:
    'Esto agregará el costo al costo total en la Orden de Trabajo.',
  required_cost_description: 'Se requiere descripción del costo',
  required_cost: 'El costo es requerido',
  add_cost: 'El costo es requerido',
  add_cost_description:
    'Complete los campos a continuación para crear y agregar costos adicionales',
  add: 'Agregar',
  hourly_rate: 'Tarifa por hora',
  include_time: 'Incluir este tiempo en el tiempo total',
  include_time_description:
    'Esto agregará la duración al tiempo total dedicado a la Orden de Trabajo',
  work_started_at: 'El trabajo comenzó a las',
  duration: 'Duración',
  hours: 'Horas',
  minutes: 'Minutos',
  required_hours: 'El campo horas es requerido',
  required_minutes: 'El campo minutos es requerido',
  add_time: 'Agregar tiempo',
  add_time_description:
    'Complete los campos a continuación para crear y agregar tiempo',
  feedback: 'Comentarios',
  feedback_description: 'Danos tu opinión',
  required_feedback: 'El campo comentario es requerido',
  signature: 'Firma',
  required_signature: 'La firma es obligatoria',
  close_wo: 'Cerrar Orden de Trabajo',
  close: 'Cerrar',
  task_update_success: 'La tarea ha sido actualizada',
  task_update_failure: 'La tarea no pudo ser actualizada',
  notes_save_success: 'Notas guardadas',
  images_add_task_success: 'La imagen ha sido agregada a la tarea',
  images_add_task_failure: 'Ocurrió un error',
  images: 'Imágenes',
  required_images: 'Por favor sube al menos una imagen.',
  add_images: 'Agregar imágenes',
  tasks: 'Tareas',
  wo_archive_success: 'La orden de trabajo ha sido archivada.',
  wo_archive_failure: 'La orden de trabajo no pudo ser archivada.',
  wo_archive_confirm:
    '¿Está seguro de que desea archivar esta orden de trabajo? ',
  quantity_change_success: 'La cantidad se modificó exitosamente',
  quantity_change_failure: 'La cantidad no se pudo modificar',
  details: 'Detalles',
  updates: 'Actualizaciones',
  id: 'ID',
  due_date: 'Fecha de vencimiento',
  location: 'Localización',
  asset: 'Activo',
  team: 'Equipo',
  created_at: 'Fecha de creación',
  list_view: 'Vista de lista',
  calendar_view: 'Vista de calendario',
  column_view: 'Vista de columna',
  wo_create_success: 'La Orden de Trabajo ha sido creada exitosamente',
  wo_create_failure: 'La Orden de Trabajo no pudo ser creada',
  changes_saved_success: 'Los cambios han sido guardados',
  wo_update_failure: 'La Orden de Trabajo no se pudo editar',
  wo_delete_success: 'La Orden de Trabajo ha sido eliminada',
  wo_delete_failure: 'La Orden de Trabajo no pudo ser eliminada',
  status: 'Estado',
  title: 'Título',
  priority: 'Prioridad',
  description: 'Descripción',
  worker: 'Trabajador',
  location_name: 'Nombre de la ubicación',
  location_address: 'Dirección',
  asset_name: 'Nombre del activo',
  days_since_creation: 'Días desde la creación',
  files: 'Archivos',
  requested_by: 'Solicitado por',
  completed_on: 'Completado el',
  updated_at: 'Actualizado el',
  work_order: 'Orden de Trabajo',
  timer_running: 'Timer corriendo',
  run_timer: 'Iniciar Timer',
  approved_by: 'Aprobado por',
  created_by: 'Creado por',
  completed_by: 'Completado por',
  time: 'Tiempo',
  save: 'Guardar',
  customers: 'Contratista',
  no_labor:
    'Aún no se han agregado costos. Aparecerán aquí cuando un usuario registre su tiempo y tenga una tarifa por hora almacenada en {{shortBrandName}}.',
  not_assigned: 'No asignado',
  no_additional_cost: 'Costos adicionales no han sido agregados aún',
  parts: 'Repuestos',
  links: 'Vínculos',
  confirm_delete_file_wo:
    '¿Está seguro de que desea eliminar este archivo de esta orden de trabajo?',
  archive: 'Archivo',
  labors: 'Tareas',
  add_additional_cost: 'Agregar costo adicional',
  additional_costs: 'Costos adicionales',
  add_parts: 'Agregar repuesto',
  'wo.title_description': 'Introduzca el título de la Orden de Trabajo',
  image: 'Imagen',
  estimated_duration: 'Duración estimada en horas',
  primary_worker: 'Trabajador principal',
  additional_workers: 'Trabajadores adicionales',
  select_team: 'Seleccionar equipo',
  select_location: 'Seleccionar ubicación',
  select_asset: 'Seleccionar activo',
  select_tasks: 'Selecccionar tareas',
  requires_signature: 'Firma requerida',
  required_wo_title: 'Se requiere el título de la Orden de Trabajo',
  add_wo: 'Agregar Orden de Trabajo',
  add_wo_description:
    'Complete los campos a continuación para crear una nueva Orden de Trabajo',
  edit_wo: 'Editar Orden de Trabajo',
  edit_wo_description:
    'Complete los campos a continuación para actualizar la Orden de Trabajo',
  'noRows.wo.message':
    'Las órdenes de trabajo son tareas o trabajos que pueden programarse o asignarse a alguien.',
  'noRows.wo.action': "Presiones el botón '+'  para crear una Orden de Trabajo",
  to_delete: 'Borrar',
  confirm_delete_wo:
    '¿Está seguro de que desea eliminar esta orden de trabajo?',
  no_access_wo:
    'No tienes acceso a las Órdenes de Trabajo. Comuníquese con su administrador si necesita tener acceso',
  cancel: 'Cancelar',
  select_parts: 'Seleccionar repuesto',
  sets_of_parts: 'Conjunto de repuestos',
  paused: 'Pausado',
  trigger_details: 'Detalles del origen',
  starts_on: 'Comienza el',
  ends_on: 'Finaliza el',
  frequency: 'Frecuencia',
  every_frequency_days: 'Cada {{frequency}} días',
  wo_details: 'Detalles de la Orden de Trabajo',
  confirm_delete_file: '¿Estás seguro de que quieres eliminar este archivo?',
  wo_schedule_success: 'Orden de Trabajo programada exitosamente',
  wo_schedule_failure: 'La Orden de Trabajo no pudo ser programada',
  wo_trigger_edit_failure:
    'No se pudo editar el originador de la Orden de Trabajo',
  wo_trigger_delete_success:
    'El activador de la Orden de Trabajo se ha eliminado correctamente',
  wo_trigger_delete_failure:
    'El activador de la Orden de Trabajo no pudo ser eliminado',
  name: 'Nombre',
  wo_title: 'Título de la Orden de Trabajo',
  next_wo: 'Próxima Orden de Trabajo',
  trigger_name: 'Nombre del disparador',
  enter_trigger_name: 'Introduzca el nombre del disparador',
  frequency_description: 'Frecuencia en días',
  wo_configuration: 'Configuración de la Orden de Trabajo',
  required_trigger_name: 'El nombre del disparador es requerido',
  required_frequency: 'La frecuencia del disparador es requerido',
  invalid_frequency: 'La frecuencia debe ser superior a 0',
  schedule_wo: 'Programar Orden de Trabajo',
  schedule_wo_description:
    'Complete los campos a continuación para programar una Orden de Trabajo',
  edit_wo_trigger: 'Editar el disparador de la Orden de Trabajo',
  edit_wo_trigger_description:
    'Complete los campos a continuación para editar el disparador de la Orden de Trabajo',
  create_trigger: 'Crear disparador',
  'noRows.pm.message':
    'Programa Ordenes de Trabajo con disparadores personalizados',
  'noRows.pm.action': "Presione el botón '+' para crear un disparador",
  confirm_delete_pm:
    '¿Está seguro de que desea eliminar este disparador de la Orden de Trabajo?',
  no_access_pm:
    'No tienes acceso a la sección de Mantenimiento Preventivo. Comuníquese con su administrador si necesita tener acceso',
  enter_wo_title: 'Ingrese el título de la Orden de Trabajo',
  status_report: 'Informe de estado',
  wo_analysis: 'Análisis de Orden de Trabajo',
  wo_aging: 'Antigüedad de la Orden de Trabajo',
  time_and_cost: 'Tiempo y costo',
  assets: 'Activos',
  reliability_dashboard: 'Panel de confiabilidad',
  total_maintenance_cost: 'Costo total del mantenimiento',
  useful_life: 'Vida útil',
  requests: 'Solicitudes',
  locations: 'Ubicaciones',
  parts_and_inventory: 'Repuestos/Inventario',
  purchase_orders: 'Órdenes de compra',
  meters: 'Mediciones',
  people_teams: 'Personas y equipos',
  people: 'Personas',
  teams: 'Equipos',
  vendors_customers: 'Proveedores y contratistas',
  vendors: 'Proveedores',
  categories: 'Categorías',
  settings: 'Ajustes',
  cancelled: 'Cancelada',
  reject: 'Rechazada',
  approve: 'Aprobada',
  request_create_success: 'Solicitud de trabajo creada exitosamente',
  request_create_failure: 'No se pudo crear la solicitud de trabajo',
  request_edit_failure: 'La solicitud no se pudo editar',
  request_delete_success: 'La solicitud ha sido eliminada exitosamente',
  request_delete_failure: 'La Solicitud no pudo ser eliminada',
  rejected: 'Rechazada',
  approved: 'Aprobada',
  pending: 'Pendiente',
  required_request_name: 'Se requiere el título de la solicitud',
  required_field: 'Este campo es requerido',
  add_request: 'Agregar solicitud',
  add_request_description:
    'Complete los campos a continuación para crear una nueva solicitud',
  edit_request: 'Editar solicitud',
  edit_request_description:
    'Complete los campos a continuación para editar la solicitud',
  'noRows.request.message': 'Gestione sus solicitudes de trabajo',
  'noRows.request.action':
    "Presione el botón '+' para crear una solicitud de trabajo",
  confirm_delete_request: '¿Está seguro de que desea eliminar esta solicitud?',
  request: 'Solicitud',
  request_details: 'Detalles de la solicitud',
  none_priority: 'Ninguna',
  low_priority: 'Baja',
  medium_priority: 'Media',
  high_priority: 'Alta',
  downtimes: 'Tiempos de inactividad',
  confirm_delete_file_asset:
    '¿Está seguro de que desea eliminar este archivo de este activo?',
  actions: 'Acciones',
  show: 'Mostrar',
  model: 'Modelo',
  serial_number: 'Número de serie',
  operational: 'Operativo',
  down: 'Inactivo',
  area: 'Área',
  barcode: 'Código de barras',
  placed_in_service: 'Puesto en servicio',
  warranty_expiration: 'Expiración de la garantía',
  asset_information: 'información',
  more_informations: 'Más información',
  confirm_delete_asset_downtime:
    '¿Estás seguro de que quieres eliminar este tiempo de inactividad?',
  create_downtime_success:
    'El tiempo de inactividad se ha agregado correctamente',
  create_downtime_failure: 'El tiempo de inactividad no pudo ser agregado',
  edit_downtime_success:
    'El tiempo de inactividad ha sido editado exitosamente',
  started_on: 'Comenzó el',
  required_startsOn: 'La fecha de inicio es obligatoria.',
  reading_create_success: 'La lectura se ha agregado con éxito.',
  reading_create_failure: 'La lectura no pudo ser agregada',
  reading: 'Lectura',
  added_by: 'Agregado por',
  enter_meter_value: 'Introduzca el valor de la medición',
  add_reading: 'Agregar lectura',
  select_meter: 'Seleccionar lectura',
  confirm_delete_part_asset:
    '¿Está seguro de que desea eliminar este repuesto de este activo?',
  no_due_date: 'Sin fecha de vencimiento',
  due_at_date: 'Pendiente {{date}}',
  no_primary_worker: 'Sin trabajador principal asignado',
  no_wo_linked_asset: 'No hay ninguna Orden de Trabajo vinculada a este activo',
  asset_remove_success: 'El activo ha sido borrado',
  asset_remove_failure: 'El activo no ha podido ser borrado',
  asset_name_description: 'Introduzca el nombre del activo',
  select_asset_location: 'Seleccione la ubicación del activo',
  primary_user_description: 'Seleccione el usuario primario',
  teams_description: 'Seleccione el equipo',
  customers_description: 'Seleccione el contratista',
  vendors_description: 'Seleccione el proveedor',
  inServiceDate_description: 'Fecha de puesta en en servicio',
  warranty_expiration_date: 'Fecha de expiración de la garantía',
  additional_information: 'Información adicional',
  structure: 'Estructura',
  parent_asset: 'Activo padre',
  asset_create_success: 'El activo ha sido creado exitosamente',
  asset_create_failure: 'El activo no pudo ser creado',
  additional_workers_description: 'Seleccione trabajadores adicionales',
  required_asset_name: 'El nombre del activo es requerido',
  add_asset: 'Agregar activo',
  add_asset_description:
    'Complete los campos a continuación para crear y agregar un nuevo activo',
  create_asset: 'Crear activo',
  hierarchy: 'Jerarquía',
  add_downtime: 'Agregar tiempo de inactividad',
  edit_downtime: 'Editar tiempo de inactividad',
  remove_downtime: 'Remover tiempo de inactividad',
  edit: 'Editar',
  edit_asset: 'Editar activo',
  edit_asset_description:
    'Complete los campos a continuación para editar este activo',
  confirm_delete_asset: '¿Está seguro de que desea eliminar este activo?',
  loading_assets: 'Cargando activo número {{name}} #{{id}}',
  no_content: 'Sin contenido',
  no_result_criteria: 'Ningún resultado coincide con sus criterios de búsqueda',
  map_view: 'Vista del mapa',
  location_create_success: 'La ubicación ha sido creada exitosamente',
  location_create_failure: 'La ubicación no pudo ser creada',
  location_edit_failure: 'La ubicación no pudo ser editada',
  location_delete_success: 'La ubicación ha sido borrada',
  location_delete_failure: 'La ubicación no pudo ser borrada',
  enter_location_name: 'Introduzca el nombre de la ubicación',
  address: 'Dirección',
  parent_location: 'Ubicación padre',
  select_workers: 'Seleccione trabajadores',
  map_coordinates: 'Mapa de coordenadas',
  required_location_name: 'El título de la ubicación es obligatorio',
  required_location_address: 'La dirección de la ubicación es obligatoria',
  add_location: 'Agregar ubicación',
  add_location_description:
    'Complete los campos a continuación para crear y agregar una nueva ubicación',
  edit_location: 'Editar ubicación',
  edit_location_description:
    'Complete los campos a continuación para actualizar la ubicación',
  confirm_delete_location:
    '¿Estás seguro de que deseas eliminar esta ubicación?',
  floor_plans: 'Planos de planta',
  floor_plan: 'Plano de planta',
  floor_plan_name_description: 'Nombre del plano de planta',
  'Floor plan area in m²': 'Superficie del plano de planta en m²',
  upload_image: 'Subir una imagen',
  required_floor_plan_name: 'El nombre del plano de planta es obligatorio.',
  add_floor_plan: 'Agregar nuevo plano de planta',
  add_floor_plan_description:
    'Complete los campos a continuación para crear un nuevo plano de planta',
  no_asset_in_location: 'Ningún activo en esta ubicación',
  no_wo_in_location: 'Ninguna Orden de Trabajo en esta ubicación',
  no_file_in_location: 'Ningún archivo adjunto a esta ubicación',
  no_floor_plan_in_location: 'Ningún plano de planta para esta ubicación',
  assigned_teams: 'Equipos asignados',
  assigned_customers: 'Contratistas asignados',
  assigned_vendors: 'Proveedores asignados',
  no_access_location:
    'No tienes acceso a Ubicaciones. Comuníquese con su administrador si necesita tener acceso',
  no_access_vendors_customers:
    'No tienes acceso a Proveedores y Contratistass. Comuníquese con su administrador si necesita tener acceso',
  no_access_people_team:
    'No tienes acceso a Personas y Equipos. Comuníquese con su administrador si necesita tener acceso',
  no_access_analytics:
    'No tienes acceso a las Estadísticas. Comuníquese con su administrador si necesita tener acceso',
  no_access_assets:
    'No tienes acceso a Activos. Comuníquese con su administrador si necesita tener acceso',
  no_access_categories:
    'No tienes acceso a Categorías. Comuníquese con su administrador si necesita tener acceso',
  no_access_files:
    'No tienes acceso a Archivos. Comuníquese con su administrador si necesita tener acceso',
  no_access_inventory:
    'No tienes acceso al Inventario. Comuníquese con su administrador si necesita tener acceso',
  no_access_meters:
    'No tienes acceso a Mediciones. Comuníquese con su administrador si necesita tener acceso',
  no_access_purchase_orders:
    'No puedes crear una orden de compra. Comuníquese con su administrador si necesita tener acceso',
  no_access_requests:
    'No tienes acceso a las Solicitudes. Comuníquese con su administrador si necesita tener acceso',
  no_access_settings:
    'No tienes acceso a Configuraciones. Comuníquese con su administrador si necesita tener acceso',
  no_access_page: 'No tienes acceso a esta página',
  file: 'Archivo',
  'noRows.location.message':
    'Las ubicaciones le permiten gestionar activos y trabajadores de forma más eficiente',
  'noRows.location.action': "Presione el botón '+' para crear una ubicación",
  card_view: 'Vista de tarjetas',
  set_create_success: 'El conjunto ha sido creado exitosamente.',
  set_create_failure: 'El conjunto no pudo ser creado',
  set_edit_failure: 'El conjunto no pudo ser editado',
  set_delete_success: 'El conjunto ha sido borrado',
  set_delete_failure: 'El conjunto no pudo ser borrado',
  total_cost: 'Costo total',
  part: 'Repuesto',
  enter_part_name: 'Introduzca el nombre del repuesto',
  required_set_name: 'Introducir el nombre es obligatorio',
  add_set: 'Agregar conjunto',
  add_set_description:
    'Complete los campos a continuación para crear y agregar un nuevo conjunto',
  create_set: 'Crear conjunto',
  edit_set: 'Editar conjunto',
  edit_set_description:
    'Complete los campos a continuación para editar el conjunto',
  confirm_delete_set: '¿Estás seguro de que quieres eliminar este conjunto?',
  part_create_success: 'El repuesto ha sido creado',
  part_create_failure: 'El repuesto no pudo ser creado',
  part_edit_failure: 'El repuesto no pudo ser editado',
  part_delete_success: 'El repuesto ha sido borrado',
  part_delete_failure: 'El repuesto no pudo ser borrado',
  quantity: 'Cantidad',
  open_wo: 'Órdenes de Trabajo abiertas',
  enter_part_category: 'Ingrese a la categoría del repuesto',
  enter_part_cost: 'Ingrese el costo del repuesto',
  enter_part_quantity: 'Ingrese la cantidad del repuesto',
  minimum_quantity: 'Cantidad mínima',
  enter_part_minimum_quantity: 'Ingrese la cantidad mínima',
  non_stock: 'Sin Stock',
  enter_part_barcode: 'Ingrese el código de barras',
  enter_part_area: 'Ingresar al área del repuesto',
  additional_part_details: 'Detalles adicionales del repuesto',
  add_part: 'Agregar repuesto',
  add_part_description:
    'Complete los campos a continuación para crear y agregar un nuevo repuesto',
  create_part: 'Crear repuesto',
  update_part: 'Actualizar repuesto',
  update_part_description:
    'Complete los campos a continuación para actualizar el repuesto',
  'noRows.part.message':
    'Los repuestos se pueden combinar en activos o usarse solos',
  'noRows.part.action': "Presione el botón '+' para crear un repuesto",
  confirm_delete_part: '¿Está seguro de que desea eliminar esta parte?',
  part_details: 'Detalles del repuesto',
  area_details: 'Detalles del área',
  assigned_people: 'Personas asignadas',
  no_asset_related_part: 'Ningún activo vinculado a este repuesto',
  no_file_found: 'Ningún archivo encontrado',
  no_wo_found: 'No se encontró ninguna Orden de Trabajo',
  workers: 'Trabajadores',
  Parts_and_Inventory: 'Partes e inventario',
  po_edit_failure: 'La orden de compra no se pudo editar',
  po_delete_success: 'La orden de compra ha sido borrada',
  po_delete_failure: 'La orden de compra no pudo ser borrada',
  number_of_items: 'Número de artículo',
  total_quantity: 'Cantidad total',
  shipping_to: 'Enviado a',
  shipping_address: 'Dirección de envío',
  po_details: 'Detalles de la orden de compra',
  enter_po_name: 'Ingrese el nombre de la orden de compra',
  additional_details: 'Detalle adicionales',
  vendor: 'Proveedor',
  shipping_information: 'Información del envío',
  company_name: 'Nombre de la empresa',
  ship_to: 'Enviado a',
  city: 'Ciudad',
  state: 'Estado',
  zip_code: 'Código postal',
  fax_number: 'Fax',
  po_date: 'Fecha de la orden de compra',
  notes: 'Notas',
  add_notes: 'Agregar notas',
  requisitioner: 'Solicitante',
  terms: 'Términos',
  shipping_method: 'Método de envío',
  required_name: 'El nombre es obligatorio',
  edit_po: 'Editar orden de compra',
  edit_po_description:
    'Complete los campos a continuación para actualizar la orden de compra',
  purchase_order: 'Orden de compra',
  'noRows.po.message': 'Gestiona tus órdenes de compra en un solo lugar',
  'noRows.po.action': "Presiona el botón  '+' para crear una orden de compra.",
  confirm_delete_po: '¿Está seguro de que desea eliminar esta orden de compra?',
  upgrade_po: 'Actualizar para crear orden de compras',
  new_po: 'Nueva orden de compra',
  po_create_success: 'La orden de compra ha sido creada exitosamente',
  select_one_part: 'Selecione al menos un repuesto ',
  po_create_failure: 'La orden de compra no pudo ser creada',
  approve_while_submitting: 'Aprobar al enviar',
  invalid_fax: 'El número de fax es inválido',
  submit: 'Entregar',
  each_item_superior_zero:
    'La cantidad de cada artículo debe ser superior a 0.',
  quantity_edit_success: 'Cantidad modificada exitosamente',
  quantity_edit_failure: 'La cantidad no pudo ser modificada',
  APPROVED: 'Aprobada',
  PENDING: 'Pendiente',
  REJECTED: 'Rechazada',
  when_reading_is: 'Cuando la lectura del medidor sea',
  greater_than: 'Mayor a',
  lower_than: 'Menor a',
  value: 'Valor',
  required_value: 'El valor es obligatorio',
  required_trigger_condition: 'La condición es requerida',
  wo_trigger_create_success:
    'El disparador de la orden de trabajo se ha creado correctamente',
  wo_trigger_create_failure:
    'El disparador de la orden de trabajo no pudo ser creado',
  add_wo_trigger: 'Agregar disparador a la orden de trabajo',
  add_wo_trigger_description:
    'Complete los campos a continuación para crear y agregar un disparador a la Orden de Trabajo',
  wo_trigger_edit_success:
    'El disparador de la Orden de Trabajo se ha actualizado correctamente',
  meter_create_success: 'La lectura ha sido creado exitosamente',
  meter_create_failure: 'La lectura no pudo ser creada ',
  meter_edit_failure: 'La lectura no pudo ser editada',
  meter_delete_success: 'La lectura ha sido borrada',
  meter_delete_failure: 'La lectura no pudo ser borrada',
  next_reading_due: 'Próxima lectura pendiente',
  unit_of_measurement: 'Unidad de medida',
  last_reading: 'Última lectura',
  enter_meter_name: 'Ingrese el nombre de la lectura',
  unit: 'Unidad',
  update_frequency: 'Frecuencia de actualización',
  update_frequency_in_days: 'Frecuencia de actualización en días',
  required_meter_name: 'El nombre de la lectura es obligatorio',
  required_meter_unit: 'La Unidad de medida es obligatoria',
  required_meter_update_frequency:
    'La frecuencia de actualización de la lectura es obligatoria',
  required_asset: 'El activo es obligatorio',
  add_meter: 'Agregar lectura',
  add_meter_description:
    'Complete los campos a continuación para crear y agregar una nueva lectura',
  edit_meter: 'Editar lectura',
  edit_meter_description:
    'Complete los campos a continuación para editar la lectura',
  confirm_delete_meter: '¿Está seguro de que desea eliminar esta lectura?',
  upgrade_create_meter: 'Actualice para crear lecturas',
  history: 'Historial',
  reading_frequency: 'Frecuencia de lectura',
  required_reading_value: 'Valor de lectura es obligatoria',
  wo_triggers: 'Desencadente de la Orden de Trabajo',
  add_trigger: 'Agregar disparador',
  meter_details: 'Detalles de lectura',
  'noRows.meter.message':
    'Las lecturas de medidores le brindan la capacidad de monitorear activos y activar nuevas órdenes de trabajo basadas en condiciones definidas.',
  'noRows.meter.action': "Presione el botón '+' para crear un medidor",
  meter: 'Medidor',
  drag_one_file: 'Arrastre un único archivo aquí',
  drag_many_files: 'Arrastre y suelte archivos aquí',
  drop_to_start: 'Suelte los archivos para comenzar la carga',
  invalid_files_type: 'No puedes subir estos tipos de archivos.',
  you_have_uploaded: 'Has subido',
  upload: 'Subido',
  Vendors_Customers: 'Proveedores y contratistas',
  customer_create_success: 'El contratista ha sido creado exitosamente',
  customer_create_failure: 'El contratista no pudo ser creado',
  customer_edit_failure: 'El contratista no pudo ser editado',
  customer_delete_success: 'El contratista ha sido borrado',
  customer_delete_failure: 'El contratista no pudo ser borrado',
  customer_name: 'Nombre del contratista',
  website: 'Sitio web',
  customer_type: 'Tipo de contratista',
  customer_type_description: 'ej. plomero, electricista',
  customer_description_description:
    'Describe el propósito de este contratista en unas pocas líneas...',
  billing_information: 'Información del envío',
  address_line_2: 'Línea de dirección 2',
  billing_name: 'Nombre del pago',
  currency: 'Moneda',
  select_currency: 'Seleccionar moneda',
  required_customer_name: 'El nombre del contratista es obligatorio',
  required_phone: 'El número de teléfono es obligatorio',
  invalid_website: 'Sitio web no válido',
  billing_address: 'Dirección de envío',
  add_customer: 'Agregar contratista',
  add_customer_description:
    'Complete los campos a continuación para crear y agregar un nuevo contratista',
  'noRows.customer.message': 'Los contratistas son trabajadores externos.',
  'noRows.customer.action': "Presione el botón '+' para crear un contratista",
  type: 'Tipo',
  billing_currency: 'Moneda de facturación',
  go_back: 'Volver',
  confirm_delete_customer:
    'Está seguro de que desea eliminar este contratista?',
  vendor_create_success: 'El proveedor ha sido creado exitosamente',
  vendor_create_failure: 'El proveedor no pudo ser creado',
  vendor_edit_failure: 'El proveedor no pudo ser editado',
  vendor_delete_success: 'El proveedor ha sido borrado',
  vendor_delete_failure: 'El proveedor no pudo ser borrado',
  required_company_name: 'El nombre de la Empresa es obligatorio',
  vendor_type: 'Tipo de proveedor',
  contact_name: 'Nombre de contacto',
  add_vendor: 'Agregar proveedor',
  add_vendor_description:
    'Complete los campos a continuación para crear y agregar un nuevo proveedor.',
  confirm_delete_vendor: '¿Está seguro de que desea eliminar este proveedor?',
  'noRows.vendor.message':
    'Los proveedores son organizaciones que proporcionan activos o repuestos.',
  'noRows.vendor.action': "Presiona el botón '+' para crear un proveedor",
  vendor_type_description: 'ej. plomería, electricidad',
  role: 'Rol',
  edit_user: 'Usuario editor',
  edit_user_description:
    'Rellene los campos a continuación para editar el usuario.',
  job_title: 'Título profesional',
  invite_users: 'Invitar usuarios',
  bring_people_team: 'Agregar nuevas personas al equipo',
  add_20_users:
    "Puede agregar 20 usuarios a la vez presionando 'tab' o 'enter' después de cada entrada de correo electrónico. Cualquier correo electrónico duplicado y registrado se eliminará al registrar a los usuarios solicitados.",
  enter_email: 'Introduzca la dirección de correo electrónico',
  users_invite_success: 'Los usuarios han sido invitados',
  users_invite_failure:
    'No se puede invitar a los usuarios. Verifique el número de miembros de su suscripción actual',
  please_type_emails: 'Por favor escriba los correos electrónicos para invitar',
  please_select_role: 'Por favor seleccione un rol',
  invite: 'Invitar',
  team_create_success: 'El equipo ha sido creado exitosamente',
  team_create_failure: 'El equipo no pudo ser creado',
  team_edit_failure: 'El equipo no pudo ser editado',
  team_delete_success: 'El equipo ha sido eliminado',
  team_delete_failure: 'El equipo no pudo ser eliminado',
  team_name: 'Nombre del equipo',
  people_in_team: 'Personas en el equipo',
  required_team_name: 'El nombre del equipo es obligatorio',
  create_team: 'Crear equipo',
  create_team_description: 'Puedes agregar miembros del equipo desde aquí',
  confirm_delete_team: '¿Estás seguro de que deseas eliminar este equipo?',
  overview: 'Decripción general',
  activity: 'Actividad',
  wo_complete_last_14_days:
    'Órdenes de Trabajo completadas en los últimos 14 días',
  no_wo_complete_last_14_days:
    'No ha completado ninguna Orden de Trabajo en las últimas dos semanas',
  ADMIN_name: 'Administrador',
  ADMIN_description:
    'El administrador tiene acceso completo; incluyendo editar, agregar y eliminar órdenes de trabajo y solicitudes',
  LIMITED_ADMIN_name: 'Administrador limitado',
  LIMITED_ADMIN_description:
    'Los administradores limitados tienen el mismo acceso que el administrador, excepto que no pueden ver/editar configuraciones ni agregar/editar personas y equipos. No pueden eliminar Órdenes de Trabajo, ubicaciones de activos, medidores y órdenes de compra a menos que hayan creado contratistas, categorías y disparadores de MP.',
  TECHNICIAN_name: 'Técnico',
  TECHNICIAN_description:
    'Los técnicos pueden crear y cerrar Órdenes de Trabajo, activos y ubicaciones. Pueden editar y eliminar solo lo que han creado.',
  LIMITED_TECHNICIAN_name: 'Técnico limitado',
  LIMITED_TECHNICIAN_description:
    'Los técnicos limitados solo pueden ver las órdenes de trabajo que se les han asignado',
  VIEW_ONLY_name: 'Solo visualización',
  VIEW_ONLY_description:
    'Los usuarios de solo visualización tienen acceso de visualización completa, pero no pueden editar nada',
  REQUESTER_name: 'Solicitante',
  REQUESTER_description:
    'Los solicitantes solo pueden enviar solicitudes de trabajo y ver su estado.',
  select_user_role: 'Seleccionar rol de usuario',
  'noRows.team.message':
    'Los equipos le ayudan a gestionar grupos específicos de personas.',
  'noRows.team.action': "Presione el botón '+' para crear un equipo.",
  user_details: 'Detalles de usuario',
  file_delete_success: 'El archivo ha sido eliminado exitosamente.',
  file_delete_failure: 'El archivo no pudo ser eliminado',
  uploaded_by: 'Subido por',
  uploaded_on: 'Subido el',
  rename: 'Renombrar',
  required_files: 'Por favor sube al menos un archivo',
  required_file_name: 'Por favor introduce un nombre para el archivo',
  add_files: 'Agregar archivos',
  edit_file: 'Editar archivos',
  'noRows.file.message': 'Tenga todos los archivos en un solo lugar',
  'noRows.file.action': "Presione el botón '+' para subir un archivo",
  upgrade_files:
    'Actualice para usar archivos en sus activos, Órdenes de Trabajo, ubicaciones, etc.',
  parts_consumption: 'Consumo de repuestos',
  requests_analysis: 'Análisis de solicitudes',
  category_create_success: 'La categoría ha sido creada exitosamente.',
  category_create_failure: 'La categoría no pudo ser creada',
  category_edit_failure: 'La categoría no pudo ser editada',
  category_delete_success: 'La categoría ha sido eliminada',
  category_delete_failure: 'La categoría no pudo ser eliminada',
  timers: 'Temporizadores',
  costs: 'Costos',
  add_category: 'Agregar nueva categoría',
  add_category_description:
    'Complete el nombre para crear y agregar una nueva categoría',
  edit_category: 'Editar categoría',
  edit_category_description: 'Complete el nombre para editar la categoría',
  no_category_action:
    "Presione el botón '+' para agregar la primera categoría.",
  confirm_delete_category: '¿Está seguro de que desea eliminar esta categoría?',
  no_category_message:
    'Parece que no tienes ninguna categoría {{categoryName}} aún.',
  acquisition_cost: 'Costo de adquisición',
  general_settings: 'Configuraciones generales',
  request_form_configuration: 'Ajustes del formulario de solicitud',
  roles: 'Roles',
  checklists: 'Checklists',
  field_configuration_description:
    'Puede marcar campos como opcionales, ocultos u obligatorios',
  optional: 'Opcional',
  required: 'Obligatorio',
  hidden: 'Oculto',
  creating_wo: 'Crear una Orden de Trabajo',
  completing_wo: 'Completar una Orden de Trabajo',
  role_edit_failure: 'El rol no pudo ser editado',
  edit_role: 'Editar rol',
  edit_role_description:
    'Complete los campos a continuación para editar el rol',
  external_id: 'ID externo',
  permissions: 'Permisos',
  create_role_description:
    'Esta función puede hacer todo lo que un administrador puede hacer en {{brandName}}, pero puede personalizar algunos permisos importantes a continuación.',
  create_and_edit: 'Crear/Editar',
  to_access: 'Accesso',
  role_delete_success: 'El rol ha sido eliminado',
  role_delete_failure: 'El rol no pudo ser eliminado',
  confirm_delete_role:
    '¿Estás seguro de que deseas eliminar permanentemente este rol?',
  users: 'Usuarios',
  paid: 'Pago',
  free: 'Gratis',
  role_create_success: 'El rol ha sido creado exitosamente',
  role_create_failure: 'El rol no pudo ser creado',
  roles_management: 'Gestión de roles',
  roles_number: '{{count}} roles',
  create_role: 'Create rol',
  upgrade_role: 'Actualice para crear roles',
  add_role: 'Agregar un nuevo rol',
  add_role_description:
    'Complete los campos a continuación para crear y agregar un nuevo rol',
  parts_and_sets: 'Repuestos y conjunto de repuestos',
  upgrade_role_edit: 'Actualice para editar roles',
  delete_role: 'Borrar rol',
  upgrade_role_delete: 'Actualice para borrar roles',
  create: 'Crear',
  pm_trigger: 'disparador de de mantenimiento preventido',
  auto_assign_wo: 'Auto-asignar Órdenes de Trabajo',
  auto_assign_wo_description:
    'Asignar automáticamente nuevas Órdenes de Trabajo a la persona que las crea',
  auto_assign_requests: 'Auto-asignar solicitudes',
  auto_assign_requests_description:
    'Asignar automáticamente nuevas Órdenes de Trabajo a la persona que aprueba la solicitud.',
  disable_closed_wo_notification:
    'Deshabilitar notificaciones de Órdenes de Trabajo cerradas',
  disable_closed_wo_notification_description:
    'Deshabilitar notificaciones cuando se actualicen Órdenes de Trabajo cerradas',
  ask_feedback_wo_closed:
    'Solicite comentarios cuando la Orden de Trabajo esté cerrada',
  ask_feedback_wo_closed_description:
    'Se pide a los usuarios que den su opinión sobre el trabajo realizado.',
  include_labor_in_total_cost:
    'Incluir el costo de la mano de obra en el costo total.',
  include_labor_in_total_cost_description:
    'Agregar costo de la mano de obra al total cuando un usuario registra el tiempo y tiene una tarifa por hora almacenada',
  enable_wo_updates_requesters:
    'Habilitar actualizaciones de órdenes de trabajo para los solicitantes',
  enable_wo_updates_requesters_description:
    'Los usuarios obtienen actualizaciones de las Órdenes de Trabajo que solicitaron.',
  language: 'Idioma',
  date_format: 'Formato de fecha',
  business_type: 'Tipo de negocio',
  general_asset_management: 'Gestión general de activos',
  physical_asset_management: 'Gestión de activos físicos',
  checklist_delete_success: 'El Checklist ha sido borrado',
  checklist_delete_failure: 'El Checklist no pudo ser borrado',
  create_checklist: 'Crear Checklist',
  confirm_delete_checklist:
    '¿Está seguro de que desea eliminar este Checklist?',
  upgrade_checklist: 'Por favor actualice para usar Checklists',
  upgrade_now: 'Actualice ahora',
  total: 'Total',
  sub_task_status: 'Estado de la subtarea',
  text_field: 'Campo de texto',
  number_field: 'Campo numérico',
  inspection_check: 'Verificación de inspección',
  multiple_choices: 'Multiples opciones',
  meter_reading: 'Lectura del medidor',
  select_user: 'Seleccionar usuario',
  PASS: 'Aprobado',
  FLAG: 'En revisión',
  FAIL: 'Desaprobado',
  enter_task_name: 'Ingrese un nombre para la tarea',
  see_details: 'Ver detalles',
  concerned_asset: 'Activo afectado',
  me: 'A mí',
  remove_blank_tasks: 'Eliminar tareas en blanco',
  remove_blank_options: 'Eliminar opciones en blanco',
  preview: 'Vista previa',
  edit_checklist: 'Editar Checklist',
  add_tasks: 'Agregar tareas',
  use_a_checklist: 'Usar un Checklist',
  select_checklist: 'Seleccionar Checklist',
  save_checklist: 'Guardar Checklist',
  assign_tasks_description:
    'Asigne tareas personalizadas para que las completen los técnicos',
  select_date: 'Seleccionar fecha',
  task: 'Tarea',
  checklist: 'Checklist',
  upgrade_analytics: 'Actualice para ver las estadísticas',
  grouped_by_category: 'Agrupados por categoría',
  downtime_by_asset: 'Tiempo de inactividad por activo',
  downtime_and_costs: 'Tiempo de inactividad y costos',
  downtime_and_costs_trends: 'Tendencias de tiempo de inactividad y costos',
  downtimes_trends: 'Tendencias de tiempo de inactividad',
  repair_time_by_asset: 'Tiempo de reparación por activo',
  consumed_parts_costs: 'Costos de repuestos consumidos',
  requests_by_priority: 'Solicitudes por prioridad',
  requests_trends: 'Tendencia de las solicitudes',
  time_spent: 'TIempo gastado',
  grouped_by_completed_by: 'Agrupado por completado por',
  grouped_by_assigned_to: 'Agrupado por asignado a',
  grouped_by_priority: 'Agrupado por prioridad',
  completion_comparison: 'Comparación de finalización',
  hours_worked: 'Horas trabajadas',
  work_remaining: 'Trabajo restante',
  wo_status: 'Estado de la Orden de Trabajo',
  cost_trends: 'Tendencia de costos',
  cost_center: 'Análisis de costos del ciclo de vida de los activos',
  downtime_and_availability: 'Tiempo de inactividad y disponibilidad',
  incomplete_wo: 'Órdenes de Trabajo incompletas',
  the_numbers: 'Los números',
  hours_and_cost_by_asset: 'Horas y costos por activos',
  completion_comparison_description:
    'Comparación de varios tipos de Órdenes de Trabajo completadas.',
  wo_age_description:
    'La antigüedad de la Orden de Trabajo se define como la cantidad de días entre la creación de la Orden de Trabajo (o solicitud de trabajo) y su finalización.',
  rav_description:
    'el VRA (valor de reemplazo del activo) es igual a (costo de las órdenes de trabajo sobre el activo/precio de compra)*100. El estándar de la industria es un valor objetivo del 3 % para esta medición.',
  downtime_and_availability_description:
    'La disponibilidad se refiere al porcentaje que los activos se encontraban en estado operativo desde su fecha de puesta en servicio. Los tiempos de inactividad totales se refieren a la cantidad de eventos de tiempo de inactividad que ocurrieron durante el rango de fechas especificado.',
  total_cost_description:
    'El costo total incluye el costo de mano de obra, el costo adicional y el costo de los repuestos en una orden de trabajo.',
  compliant_wo_description:
    'Las Órdenes de Trabajo cumplidas se definen como Órdenes de Trabajo que se completaron antes de la fecha de vencimiento. El tiempo del ciclo se refiere a la cantidad de días hasta que se completó una orden de trabajo.',
  hours_worked_description:
    'Estas horas corresponden a Órdenes de Trabajo que tienen fecha de vencimiento dentro del rango especificado en los filtros.',
  work_remaining_description:
    'Este gráfico muestra la cantidad de Órdenes de Trabajo incompletas que vencen en el rango de fechas especificado en los filtros. Las horas estimadas corresponden a esas órdenes de trabajo individuales.',
  total_downtime_in_hours: 'Total de tiempo de inactividad (horas)',
  downtime_events: 'Eventos de tiempo de inactividad',
  percent_downtime: '% tiempo de inactividad',
  meantime_between_failures_in_hours: 'Tiempo medio entre fallos (horas)',
  availability_percent: 'Porcentaje de disponibilidad',
  mean_time_to_repair_in_hours: 'Tiempo medio de reparación (horas)',
  average_age: 'Tiempo medio de reparación (horas)',
  count: 'Resultado',
  average_cost: 'Costo promedio',
  compliant: 'Conformidad',
  average_cycle_time_in_days: 'Tiempo de ciclo promedio (días)',
  total_consumption_cost: 'Costo total de consumo',
  parts_consumed: 'Repuestos consumidos',
  total_cost_as_pct_rav: 'Costo total como porcentaje del VRA',
  approved_requests: 'Solicitudes aprobadas',
  pending_requests: 'Solicitudes pendientes',
  cancelled_requests: 'Solicitudes canceladas',
  average_cycle_time: 'Tiempo de ciclo promedio',
  compliance_rate: 'Tasa de cumplimiento',
  complete: 'Completo',
  reactive: 'Reactivo',
  recurring: 'Recurrente',
  part_costs: 'Costo de los repuestos',
  labor_costs: 'Costo de la mano de obra',
  total_time_spent_in_hours: 'Tiempo total empleado (Horas)',
  estimated_hours: 'Horas estimadas',
  total_purchase_price: 'Precio total de compra',
  you_have: 'Tienes',
  new_messages: 'nuevos mensajes',
  company: 'Empresa',
  change_cover: 'Cambiar portada',
  required_address: 'La dirección es obligatoria',
  company_details: 'Detalles de la Empresa',
  company_details_description:
    'Gestionar información relacionada con su Empresa',
  learn_more: 'Aprenda más',
  profile: 'Perfil',
  email_notifications: 'Notificaciones por correo electrónico',
  email_updates_wo:
    'Actualizaciones por correo electrónico para órdenes de trabajo y mensaje',
  email_updates_requests:
    'Actualizaciones por correo electrónico para órdenes de trabajo solicitadas',
  po_emails: 'Correos electrónicos de pedidos de compra',
  required_job_title: 'El campo título del puesto es obligatorio',
  required_old_password: 'Por favor proporcione la contraseña actual.',
  invalid_password:
    'La contraseña es demasiado corta. Debe tener un mínimo de 8 caracteres.',
  required_new_password: 'No se proporcionó contraseña.',
  passwords_must_match: 'Las contraseñas deben coincidir',
  password_change_success: 'Contraseña modificada exitosamente',
  wrong_password: 'Contraseña incorrecta',
  current_password: 'Contraseña actual',
  new_password: 'Nueva contraseña',
  confirm_password: 'Confirmar contraseña',
  personal_details: 'Detalles personales',
  personal_details_description:
    'Gestionar información relacionada con sus datos personales',
  change_password: 'Cambiar contraseña',
  notification_settings: 'Configuración de notificaciones',
  notification_settings_description:
    'Gestiona los detalles relacionados con tus notificaciones.',
  recent_activity: 'Actividad reciente',
  created: 'Creada',
  completed: 'Completada',
  my_account: 'Mi cuenta',
  my_company: 'Mi Empresa',
  you_are_using_plan:
    'Actualmente estás utilizando el plan {{planName}}. Caducará el {{expiration}}. Actualice ahora para obtener acceso a más funciones.',
  upgrade_plan: 'Actualizar plan',
  plans: 'Planes',
  monthly: 'Mensual',
  annually: 'Anual',
  subscription_change_success: 'La suscripción se ha cambiado correctamente.',
  invalid_credit_card: 'El número de tarjeta de crédito no es válido',
  required_credit_card: 'El campo de la tarjeta es obligatorio.',
  invalid_expiration_month: 'El mes de vencimiento no es válido',
  required_expiration_month: 'El mes de vencimiento es obligatorio',
  invalid_expiration_year: 'El año de vencimiento no es válido',
  required_expiration_year: 'El mes de vencimiento es obligatorio',
  invalid_cvv: 'CVV no es válido',
  required_cvv: 'El CVV es obligatorio',
  required_cardholder_name:
    'El nombre del titular de la tarjeta es obligatorio.',
  card: 'Tarjeta',
  expiration_month: 'Mes de vencimiento',
  expiration_year: 'Año de vencimiento',
  cardholder_name: 'Nombre del titular de la tarjeta',
  seats: 'Puestos',
  cost_per_seat: 'Costo por puesto',
  your_payment_secure: 'Sus datos de pago están encriptados y seguros.',
  plan: 'Plan',
  current_plan: 'Plan actual',
  number_users_who_will_use_grash:
    'Número de usuarios que utilizarán {{shortBrandName}}',
  admin_role: 'Administrador',
  technical_role: 'Técnico',
  limited_technical_role: 'Técnico limitado',
  requester_role: 'Solicitud',
  view_only_role: 'Solo visualización',
  how_will_you_be_billed: '¿Cómo le gustaría que se le facture?',
  which_plan_fits_you: '¿Qué plan se adapta mejor a ti?',
  per_user_month: 'Por usuario/mes',
  per_user_year: 'Por usuario/año',
  you_will_be_charged: 'Se le cobrará',
  proceed_to_payment: 'Proceder al pago',
  pay_only_for_roles:
    'Pague solo por usuarios <strong>Administrador</strong>, <strong>Técnico</strong> y <strong>Técnico limitado</strong>, y use usuarios <strong>Solicitante</strong> y <strong>Solo visualización</strong> ilimitados de forma gratuita.',
  checkout_our: 'Echa un vistazo a nuestra',
  pricing_page: 'página de precios',
  for_more_details: 'para más detalles',
  users_count_display: '{{count}} usuarios',
  monthly_adverb: 'Mensual',
  yearly_adverb: 'Anual',
  features: 'Características',
  checkout: 'Verificar',
  checkout_description: 'Rellene los campos que aparecen a continuación',
  per_month: 'por mes',
  per_year: 'por año',
  recover_password_description:
    'Ingrese el correo electrónico utilizado para el registro para restablecer su contraseña.',
  send_me_new_password: 'Envíenme una nueva contraseña',
  want_to_sign_in_again: '¿Quieres intentar iniciar sesión nuevamente?',
  check_mails_for_instructions:
    'Revise su correo electrónico para obtener más instrucciones.',
  pdf_report: 'Reporte en PDF',
  HIGH: 'Alta',
  MEDIUM: 'Media',
  LOW: 'Baja',
  NONE: 'Ninguna',
  import: 'Importar',
  start_import_process: 'Iniciar proceso de importación',
  import_data: 'Importar datos',
  set_header: 'Establecer encabezado',
  match_columns: 'Coincidir columnas',
  review: 'Revisar',
  done: 'Hecho',
  no_match_yet: 'No hay coincidencia todavía',
  select: 'Seleccionar...',
  matched_to_field: 'Coincidencia en {{field}}',
  next: 'Siguiente',
  not_enough_rows: 'No hay suficientes filas en el archivo',
  there_are_duplicates: 'Hay {{duplicates}} duplicados',
  assigned_by: 'Asignado a',
  percent_rows_have_value: '{{percent}}% de filas tienen valor',
  match_at_least_column: 'Coincide al menos con una columna',
  to_import: 'Importar',
  required_match: '{{field}} se requiere coincidencia',
  archived: 'Archivado',
  import_wo_success:
    '{{created}} Órdenes de Trabajo han sido creadas y {{updated}} han sido actualizadas',
  to_export: 'Exportar',
  filters: 'Filtros',
  more_filters: 'Más filtros',
  customer: 'Contratista',
  to: 'a',
  dates: 'Fechas',
  start: 'Comienza',
  end: 'Termina',
  longitude: 'Longitud',
  latitude: 'Latitud',
  ALL: 'Todos',
  REACTIVE: 'Reactivo',
  REPEATING: 'Preventivo',
  import_location_success:
    '{{created}} ubicaciones han sido creadas y {{updated}} ubicaciones han sido actualizadas',
  import_part_success:
    '{{created}} repuestos han sido creados y {{updated}} repuestos han sido actualizados',
  import_meter_success:
    '{{created}} lecturas han sido creados y {{updated}} lecturas han sido actualizadas',
  import_asset_success:
    '{{created}} activos han sido creados y {{updated}} activos han sido actualizados',
  wo_calendar: 'Calendario de órdenes de trabajo',
  month: 'Mes',
  week: 'Semana',
  day: 'Día',
  agenda: 'Agenda',
  previous: 'Previo',
  today: 'Hoy',
  to_filter: 'Filtro',
  'noRows.asset.message':
    'Los activos son recursos sobre los que su empresa puede intervenir',
  'noRows.asset.action': "Presione el botón '+' para crear un nuevo activo.",
  reset_filters: 'Borrar filtros',
  toggle_menu: 'Menú desplegable',
  no_results: 'No se encontraron resultados',
  an_error_occured: 'Ocurrió un error.',
  density: 'Densidad',
  compact: 'Compacto',
  standard: 'Estándar',
  comfortable: 'Comfortable',
  columns: 'Columnas',
  select_columns: 'Seleccionar columnas',
  show_filters: 'Mostrar filtros',
  hide_filters: 'Ocultar filtros',
  search_placeholder: 'Buscar…',
  search: 'Buscar',
  clear: 'Limpiar',
  download_as_csv: 'Descargar como CSV',
  print: 'Imprimir',
  download_as_excel: 'Descargar como Excel',
  find_column: 'Encontrar columna',
  column_title: 'Título de la columna',
  reorder_column: 'Reordenar columna',
  show_all: 'Mostrar todo',
  hide_all: 'Ocultar todo',
  add_filter: 'Agregar filtro',
  logic_operator: 'Operador lógico',
  operator: 'Operador',
  and: 'Y',
  or: 'O',
  filter_value: 'Valor del filtro',
  contains: 'contiene',
  equals: 'igual',
  starts_with: 'comienza con',
  ends_with: 'termina con',
  is: 'es',
  is_not: 'no es',
  is_after: 'es después',
  is_on_or_after: 'está en o después',
  is_before: 'es antes',
  is_on_or_before: 'está en o antes',
  is_empty: 'está vacío',
  is_not_empty: 'no está vacío',
  is_any_of: 'es cualquiera de',
  any: 'cualquiera',
  true_text: 'verdadero',
  false_text: 'falso',
  menu: 'Menú',
  show_columns: 'Mostrar columnas',
  hide: 'Ocultar',
  unsort: 'Desclasificar',
  sort_by_ASC: 'Ordenar por ASC',
  sort_by_DESC: 'Ordenar por DESC',
  sort: 'Ordenar',
  total_rows: 'Filas totales:',
  yes: 'Si',
  no: 'No',
  more: 'Más',
  to_group: 'Grupo',
  see_children: 'Ver hijos',
  hide_children: 'Ocultar hijos',
  expand: 'Expandir',
  collapse: 'Colapsar',
  detail_panel_toggle: 'Alternar panel de detalles',
  cancel_subscription: 'Cancelar suscripciónn',
  resume_subscription: 'Reanudar suscripción',
  confirm_cancel_subscription:
    '¿Estás seguro de que deseas cancelar la suscripción?',
  workflows: 'Flujo de trabajo',
  create_workflow: 'Crear flujo de trabajo',
  if: 'Si',
  and_optional: 'y (opcional)',
  then: 'entonces',
  workflow_description:
    'Cree flujos de trabajo personalizados con la misma facilidad que If, And, Then. Ahorre tiempo y asigne fácilmente sus Órdenes de Trabajo automáticamente a través de flujos de trabajo para personalizar {{shortBrandName}} de acuerdo con la forma en que opera su equipo. Todos los planes pueden crear hasta 1 flujo de trabajo personalizado. Para agregar flujos de trabajo adicionales, actualice a nuestro plan Business',
  CREATE_PURCHASE_ORDER: 'Crear orden de compra',
  PART_IS: 'El repuesto es',
  QUANTITY_INFERIOR: 'La cantidad es inferior a',
  ASSIGN_VENDOR: 'Asignar proveedor',
  ASSIGN_CATEGORY: 'Asignar la categoría',
  APPROVE: 'Aprobar',
  REJECT: 'Rechazar',
  SEND_REMINDER_EMAIL: 'Enviar recordatorio por correo electrónico',
  VENDOR_IS: 'El proveedor es',
  CATEGORY_IS: 'La categoría es',
  STATUS_IS: 'El estado es',
  DUE_DATE_BETWEEN: 'La fecha de vencimiento es entre',
  DUE_DATE_AFTER: 'La fecha de vencimiento es después de',
  ASSIGN_PRIORITY: 'Asignar la prioridad',
  ASSIGN_ASSET: 'Asignar el activo',
  ASSIGN_LOCATION: 'Asignar la ubicación',
  ASSIGN_USER: 'Asignar el usuario',
  ASSIGN_TEAM: 'Asignar el equipo',
  ADD_CHECKLIST: 'Agregar Checklist',
  PRIORITY_IS: 'La prioridad es',
  ASSET_IS: 'El activo es',
  LOCATION_IS: 'La ubicación es',
  USER_IS: 'El usuario es',
  TEAM_IS: 'El equipo es',
  CREATED_AT_BETWEEN: 'Se crea entre',
  TITLE_CONTAINS: 'El título contiene',
  CREATE_REQUEST: 'Crear una solicitud',
  CREATE_WORK_ORDER: 'Crear una Órden de Trabajo',
  SET_ASSET_STATUS: 'Establecer el estado del activo',
  NAME_IS: 'EL nombre es',
  NAME_CONTAINS: 'El nombre contiene',
  VALUE_IS: 'El valor es',
  VALUE_CONTAINS: 'El valor contiene',
  NUMBER_VALUE_SUPERIOR: 'El valor es superior a',
  NUMBER_VALUE_INFERIOR: 'El valor es inferior a',
  WORK_ORDER_CREATED: 'Se crea una Orden de Trabajo',
  WORK_ORDER_CLOSED: 'Una Orden de Trabajo está cerrada',
  WORK_ORDER_ARCHIVED: 'Una Orden de Trabajo está archivada',
  REQUEST_CREATED: 'Se crea una solicitud',
  REQUEST_APPROVED: 'Se aprueba una solicitud',
  REQUEST_REJECTED: 'Se rechaza una solicitud',
  PURCHASE_ORDER_CREATED: 'Se crea una orden de compra',
  PURCHASE_ORDER_UPDATED: 'Se modifica una orden de compra',
  TASK_UPDATED: 'Se actualiza una tarea',
  PART_UPDATED: 'Se actualiza un repuesto',
  add_condition: 'Agregar condición',
  workflow_creation_success: 'Flujo de trabajo ha sido creado',
  workflow_creation_failure: 'Flujo de trabajo no pudo ser creado',
  action_value_missing: 'Falta el valor de la acción',
  condition_value_missing: 'Falta un valor de condición',
  workflow_edit_success: 'El flujo de trabajo se ha actualizado correctamente',
  workflow_edit_failure: 'El flujo de trabajo no pudo ser editado',
  workflow_delete_success: 'El flujo de trabajo se ha eliminado',
  workflow_delete_failure: 'El flujo de trabajo no pudo ser eliminado',
  confirm_delete_workflow:
    '¿Estás seguro de que quieres eliminar este flujo de trabajo?',
  click_here: 'Haga clic aquí',
  verify_email_title: 'Verificar correo electrónico',
  verify_email_description:
    'Se te ha enviado un correo electrónico de verificación. Revisa la carpeta de spam si no lo ves en tu bandeja de entrada.',
  upgrade: 'Upgrade',
  downgrade: 'Downgrade',
  upgrade_description:
    'Acaba de actualizar su plan de suscripción. Debe habilitar a los usuarios deshabilitados que podrían usar {{shortBrandName}}. Solo puede hacer esto una vez para la suscripción actual. Elija con cuidado',
  enable_users: 'Habilitar usuarios',
  max_users_description: 'Puede habilitar hasta {{maxUsers}} usuarios',
  downgrade_description:
    'Acabas de cambiar a una versión inferior de tu plan de suscripción. Debes desactivar algunos usuarios para continuar. Solo puedes hacerlo una vez para la suscripción actual. Elija con cuidado.',
  disable_users: 'Deshabilitar usuarios',
  min_users_description: 'Debes desactivar un mìnimo de {{minUsers}} usuarios',
  downgrade_description_no_owner:
    'Su empresa acaba de reducir su plan de suscripción. El propietario de la empresa debe deshabilitar algunos usuarios antes de poder continuar.',
  past_due: 'Vencido',
  due_date_delay: 'Retraso en la fecha de vencimiento',
  due_date_delay_description: 'Retraso de fecha de vencimiento en días',
  days_count: '{{days}} días',
  trigger_configuration: 'Configuración de los diparadores',
  WORK_ORDER_feature: 'Órdenes de Trabajo',
  REQUEST_feature: 'Solicitudes de trabajo',
  PART_feature: 'Gestión de repuestos',
  MOBILE_APP_feature: 'Aplicación móvil',
  WORK_ORDER_HISTORY_feature: 'Historial de Órdenes de Trabajo',
  PREVENTIVE_MAINTENANCE_feature: 'Mantenimiento Preventivo',
  CHECKLIST_feature: 'Checklists',
  FILE_feature: 'Archivos subidos',
  PURCHASE_ORDER_feature: 'Órdenes de compra',
  METER_feature: 'Mediciones',
  REQUEST_CONFIGURATION_feature: 'Configuración del formulario de solicitud',
  ADDITIONAL_TIME_feature: 'Seguimiento de tiempo avanzado',
  ADDITIONAL_COST_feature: 'Seguimiento de costos avanzado',
  ANALYTICS_feature: 'Estadísticas y reportes',
  REQUEST_PORTAL_feature: 'Portal de solicitudes',
  SIGNATURE_feature: 'Firmas',
  ROLE_feature: 'Roles personalizados',
  WORKFLOW_feature: 'Automatización del flujo de trabajo',
  API_ACCESS_feature: 'Acceso API',
  WEBHOOK_feature: 'Webhooks',
  add_new_option: 'Agregar una nueva opción',
  edit_company: 'Editar Empresa',
  fill_fields_below: 'Rellene los campos que aparecen a continuación',
  IMPORT_CSV_feature: 'Importación de CSV',
  no_import_access:
    'Actualice su plan para importar desde archivos CSV y Excel',
  members: 'Miembros',
  assign_user: 'Asignar usuario',
  assign_asset: 'Asignar activo',
  required_files_on_completion:
    'Se requieren archivos al completar la Orden de Trabajo',
  required_tasks_on_completion: 'Las tareas deben completarse',
  required_labor_on_completion: 'Debes registrar el tiempo',
  required_part_on_completion:
    'No se ha utilizado ningún repuesto en esta Orden de Trabajo',
  required_cost_on_completion:
    'No se proporciona información de costos en esta Orden de Trabajo',
  estimated_hours_in_text: '{{hours}} horas estimadas',
  required_part_name: 'Nombre del repuesto es obligatorio',
  asset_update_failure: 'No se pudo editar el activo',
  terms_of_service: 'Términos del servicio',
  privacy_policy: 'Política de privacidad',
  last_login: 'Último inicio de sesión',
  not_enough_part: 'No hay suficiente cantidad de este repuesto',
  remove_blank_meter_tasks: 'Eliminar tareas con medidor de tipo sin medidor',
  checklist_update_failure: 'El Checklist no pudo ser editado',
  contact_us: 'Contáctenos',
  simplify_wo: 'Simplifique las Órdenes de Trabajo en la aplicación móvil',
  simplify_wo_description:
    'Oculte controles de tiempo, costos y piezas en los detalles de la orden de trabajo mientras usa la aplicación móvil',
  account_deletion: 'Eliminar cuenta',
  switch_account: 'Cambiar cuenta',
  switch_to_super_user: 'Cambiar a superadministrador',
  switch_account_description: 'Seleccione una cuenta para continuar',
  put_location_in_map: 'Poner ubicación en el mapa',
  confirm_disable_user:
    '¿Estás seguro de que deseas desactivar {{user}}? Solo podrás habilitarlo después de un mes',
  user_disabled_success: 'Usuario deshabilitado exitosamente',
  disable: 'Desactivado',
  manufacturer: 'Fabricante',
  power: 'Potencia',
  import_error: 'La importación no se realizó',
  request_upgrade: 'Actualizar solicitud',
  operation_success: 'La operación fue un éxito',
  CANCELLED: 'Rechazado',
  uptime_hours: 'Tiempo de actividad (h)',
  downtime_hours: 'Tiempo de inactividad (h)',
  mark_all_as_seen: 'Marcar todo como visto',
  estimation_accuracy_ratio: 'Relación de precisión de la estimación',
  download_template: 'Descargar plantilla',
  pareto_by_total_price: 'Pareto por precio total',
  cumulative_percent: 'Porcentaje acumulado',
  part_consumption_by_asset: 'Repuestos consumidos por activo',
  grouped_by_wo_category: 'Agrupado por categoría de Orden de Trabajo',
  resolution_rate: 'Tasa de resolución',
  resolved: 'Resuelto',
  average: 'Promedio',
  documentation: 'Documentación',
  days_before_pm_notification:
    'Notificaciones previas a las órdenes de trabajo programadas',
  estimated_start_date: 'Fecha de inicio prevista',
  no_file_linked_to_wo: 'No hay ningún archivo adjunto a esta Orden de Trabajo',
  add_file: 'Agregar archivo',
  try_for_free: 'Prueba gratis',
  choose_your_plan: 'Elige tu plan',
  STARTER_description:
    'Equipos que buscan desarrollar un mantenimiento preventivo eficiente y sólido a través del estado de las máquinas y la visibilidad de la mano de obra.',
  PROFESSIONAL_description:
    'Departamentos que necesitan aprovechar los conocimientos y los análisis para impulsar un mayor crecimiento y productividad del mantenimiento.',
  BUSINESS_description:
    'Organizaciones listas para capturar datos de mantenimiento y operaciones para administrar múltiples ubicaciones y personalizar el sistema.',
  book_demo: 'Solicitar una demo',
  request_pricing: 'Solicite más información',
  Reports: 'Informes',
  'Custom dashboard built using the included components':
    'Tablero personalizado construido usando los componentes incluidos',
  Export: 'Exportar',
  'Last year': 'El año pasado',
  Expenses: 'Gastos',
  Statistics: 'Estadística',
  General: 'General',
  Calendar: 'Calendario',
  Mailbox: 'Buzones',
  Dashboards: 'Paneles',
  Analytics: 'Estadísticas',
  Monitoring: 'Escucha',
  Tasks: 'Tareas',
  Applications: 'Aplicaciones',
  Users: 'Usuarios',
  'List All': 'Todo',
  'User Profile': 'Perfil de usuario',
  Login: 'Conectar',
  Register: 'Registro',
  'Recover Password': 'Recuperar contraseña',
  Status: 'Estado',
  'Error 404': 'Error 404',
  'Error 500': 'Error 500',
  'Coming Soon': 'Futuro',
  Maintenance: 'Mantenimiento',
  Overview: 'Avance',
  Documentation: 'Documentación',
  Welcome: 'Bienvenido',
  Help: 'Ayuda',
  'Features tour': 'Visita de características',
  'Getting started guide': 'Guía de inicio',
  'Contact support': 'Póngase en contacto con el soporte',
  Version: 'Versión',
  Search: 'Buscar',
  Notifications: 'Notificaciones',
  Settings: 'Parámetros',
  'Language Switcher': 'Selector de idiomas',
  'Sign out': 'Desconexión',
  'Change Theme': 'Cambiar el tema',
  'View all notifications': 'Mostrar todas las notificaciones',
  dashboards: 'paneles',
  applications: 'aplicaciones',
  'management sections': 'Secciones de gestión',
  'dark/light themes': 'Temas oscuros / claros',
  components: 'componentes',
  rate: 'Frecuencia',
  select_at_least_column: 'Hacer una coincidencia de columna al menos',
  already_read: 'Encuesta',
  OPERATIONAL: 'Operativo',
  DOWN: 'Fuera de servicio',
  MODERNIZATION: 'Modernización',
  STANDBY: 'En espera',
  INSPECTION_SCHEDULED: 'Inspección programada',
  COMMISSIONING: 'Puesta en marcha',
  EMERGENCY_SHUTDOWN: 'Apagado de emergencia',
  select_asset_status: 'Seleccionar estado del activo',
  asset_status: 'Estado del activo',
  ui_configuration: 'Configuración de la interfaz',
  password_leave_empty_if_you_dont_want_to_change:
    'Contraseña: déjalo vacío si no quieres cambiarla',
  upgrade_request_success:
    '¡Solicitud de actualización recibida! Nos pondremos en contacto contigo pronto con los detalles de pago',
  continue_with_sso: 'Continuar con SSO',
  see_live_demo: 'Ver demostración en vivo',
  days: 'Días',
  weeks: 'Semanas',
  months: 'Meses',
  years: 'Años',
  based_on: 'Basado en',
  scheduled_date: 'Fecha programada',
  on: 'En',
  required_days_of_week: 'Días de la semana requeridos',
  'schedule.daily_one': 'Cada {{count}} día',
  'schedule.daily_other': 'Cada {{count}} días',
  'schedule.weekly_one': 'Cada {{count}} semana en {{days}}',
  'schedule.weekly_other': 'Cada {{count}} semanas en {{days}}',
  'schedule.monthly_one': 'Cada {{count}} mes',
  'schedule.monthly_other': 'Cada {{count}} meses',
  'schedule.yearly_one': 'Cada {{count}} año',
  'schedule.yearly_other': 'Cada {{count}} años',
  delete_account: 'Eliminar cuenta',
  csv_separator: 'Separador CSV',
  open_source_cmms: 'CMMS de código abierto',
  'main.title':
    'CMMS gratuito de código abierto (software de gestión de mantenimiento) – ',
  'home.h1':
    'CMMS gratuito y de código abierto que puede alojar usted mismo o usar en la nube',
  'home.h2': 'Mantenimiento potente a bajo coste',
  'home.h3':
    'Deje de depender de hojas de cálculo y pizarras. {{brandName}} ayuda a los equipos de mantenimiento a planificar intervenciones, rastrear equipos y mantenerse en cumplimiento. Alójelo en su propio servidor o comience instantáneamente en la nube.',
  talk_to_sales: 'Hablar con ventas',
  'pricing.choose_plan_and_get_started': 'Elige tu plan y empieza',
  'pricing.slogan_effective_maintenance':
    'Nuestro software brinda a los equipos de mantenimiento y confiabilidad las herramientas que necesitan para ejecutar las operaciones de manera eficiente y eficaz.',
  'pricing.compare_plans_and_pricing': 'Comparar planes y precios',
  'pricing.see_which_plan_is_right_for_you':
    'Vea qué plan es adecuado para usted',
  'pricing.select_two_plans_to_compare': 'Seleccione 2 planes para comparar',
  'pricing.select_three_plans_to_compare': 'Seleccione 3 planes para comparar',
  'pricing.month_per_user': 'mes por usuario',
  'pricing.year_per_user': 'año por usuario',
  'pricing.plan_basic_name': 'Básico',
  'pricing.plan_basic_description':
    'Equipos que buscan rastrear activos y crear cronogramas fundamentales de mantenimiento preventivo con procedimientos.',
  'pricing.feature_unlimited_work_orders': 'Órdenes de trabajo ilimitadas',
  'pricing.feature_custom_tasks': 'Tareas personalizadas',
  'pricing.feature_unlimited_request_user_licenses':
    'Solicitudes de licencias de usuario ilimitadas',
  'pricing.plan_starter_name': 'Motor de arranque',
  'pricing.plan_starter_description':
    'Equipos que buscan construir un mantenimiento preventivo eficiente y sólido a través del estado de las máquinas y la visibilidad de la mano de obra.',
  'pricing.feature_everything_in_basic_plus': 'Todo lo del plan Básico más:',
  'pricing.feature_preventive_maintenance_recurring_work_orders':
    'Mantenimiento preventivo/Órdenes de trabajo recurrentes',
  'pricing.feature_custom_checklists': 'Listas de verificación personalizadas',
  'pricing.feature_inventory_management_costing':
    'Gestión de inventario/Costes',
  'pricing.feature_time_and_manpower_tracking':
    'Seguimiento del tiempo y la mano de obra',
  'pricing.feature_thirty_day_analytics_reporting':
    'Análisis e informes de 30 días',
  'pricing.plan_professional_name': 'Profesional',
  'pricing.plan_professional_description':
    'Departamentos que necesitan aprovechar conocimientos y análisis para impulsar un mayor crecimiento y productividad del mantenimiento.',
  'pricing.feature_everything_in_starter_plus':
    'Todo lo incluido en Starter más:',
  'pricing.feature_multiple_inventory_lines': 'Múltiples líneas de inventario',
  'pricing.feature_customizable_request_portal':
    'Portal de solicitudes personalizable',
  'pricing.feature_mobile_offline_mode': 'Modo móvil sin conexión',
  'pricing.feature_advanced_analytics_reporting':
    'Análisis e informes avanzados',
  'pricing.plan_business_name': 'Negocio',
  'pricing.plan_business_description':
    'Organizaciones listas para capturar datos de mantenimiento y operaciones para administrar múltiples ubicaciones y personalizar el sistema.',
  'pricing.feature_everything_in_professional_plus':
    'Todo lo del plan Profesional más:',
  'pricing.feature_purchase_order_management': 'Gestión de órdenes de compra',
  'pricing.feature_multi_site_module_support': 'Soporte de módulos multisitio',
  'pricing.feature_custom_work_order_statuses':
    'Estados de órdenes de trabajo personalizadas',
  'pricing.feature_custom_integrations_support':
    'Soporte para integraciones personalizadas',
  'pricing.feature_work_order_management': 'Gestión de órdenes de trabajo',
  'pricing.feature_recurring_work_orders': 'Órdenes de trabajo recurrentes',
  'pricing.feature_custom_categories': 'Categorías personalizadas',
  'pricing.feature_data_importing': 'Importación de datos',
  'pricing.feature_time_and_cost_tracking': 'Seguimiento de tiempo y costos',
  'pricing.feature_work_order_configuration':
    'Configuración de órdenes de trabajo',
  'pricing.feature_internal_requests': 'Solicitudes internas',
  'pricing.feature_external_request_portal': 'Portal de solicitudes externas',
  'pricing.category_locations_assets_parts': 'Ubicaciones, activos y piezas',
  'pricing.feature_location_management': 'Gestión de ubicaciones',
  'pricing.feature_barcode_scanning': 'Escaneo de código de barras',
  'pricing.feature_inventory_management': 'Gestión de inventario',
  'pricing.feature_custom_asset_statuses': 'Estados de activos personalizados',
  'pricing.feature_asset_downtime_tracking':
    'Seguimiento del tiempo de inactividad de los activos',
  'pricing.feature_asset_depreciation_tracking':
    'Seguimiento de la depreciación de activos',
  'pricing.feature_asset_warranty_tracking':
    'Seguimiento de la garantía de activos',
  'pricing.feature_purchase_orders_management': 'Órdenes de compra',
  'pricing.feature_asset_check_in_out': 'Registro de entrada/salida de activos',
  'pricing.category_mobile_offline': 'Móvil sin conexión',
  'pricing.feature_work_order_availability':
    'Disponibilidad de órdenes de trabajo',
  'pricing.feature_updating_status': 'Actualización de estado',
  'pricing.feature_updating_tasks': 'Actualización de tareas',
  'pricing.feature_work_order_drafts': 'Borradores de órdenes de trabajo',
  'pricing.feature_full_drill_down_reporting_history':
    'Informes y historial completos y detallados',
  'pricing.period_thirty_days': '30 días',
  'pricing.period_full': 'Lleno',
  'pricing.feature_pdf_csv_exporting': 'Exportación de PDF y CSV',
  'pricing.feature_itemized_time_reporting': 'Informes de tiempo detallados',
  'pricing.feature_user_login_reports':
    'Informes de inicio de sesión de usuario',
  'pricing.feature_parts_consumption_reports': 'Informes de consumo de piezas',
  'pricing.feature_asset_downtime_reports':
    'Informes de tiempo de inactividad de activos',
  'pricing.feature_equipment_reliability_reports':
    'Informes de confiabilidad de equipos',
  'pricing.feature_multi_site_modules': 'Módulos multisitio',
  'pricing.category_integrations': 'Integraciones',
  'pricing.feature_business_integrations':
    'Integraciones empresariales (SAP/Oracle/Causal AI...)',
  'pricing.feature_custom_integrations': 'Integraciones personalizadas',
  'pricing.feature_unlimited_view_only_users':
    'Usuarios ilimitados de solo lectura',
  'pricing.feature_unlimited_requesters': 'Solicitantes ilimitados',
  'pricing.feature_unlimited_vendors': 'Vendedores ilimitados',
  'pricing.feature_unlimited_customers': 'Clientes ilimitados',
  'pricing.category_support': 'Apoyo',
  'pricing.feature_daily_email_digest': 'Resumen diario por correo electrónico',
  'pricing.feature_articles': 'Artículos',
  'pricing.feature_training_webinars': 'Seminarios web de capacitación',
  'pricing.feature_community_support_discord': 'Soporte comunitario (Discord)',
  'pricing.feature_email_support': 'Soporte por correo electrónico',
  'pricing.feature_chat_phone_support': 'Soporte por chat/teléfono',
  'pricing.feature_priority_support': 'Soporte prioritario',
  'pricing.feature_implementation_training': 'Implementación y capacitación',
  'pricing.feature_dedicated_account_manager': 'Gerente de cuenta dedicado',
  'pricing.category_customization': 'Personalización',
  'pricing.feature_custom_development': 'Desarrollo personalizado',
  'pricing.sh_plan_basic_name': 'Básico',
  'pricing.sh_plan_basic_description':
    'Para equipos pequeños que necesitan soberanía total de datos y seguimiento básico del mantenimiento en su propia infraestructura.',
  'pricing.sh_feature_core_work_order_management':
    'Gestión de órdenes de trabajo básicas',
  'pricing.sh_feature_asset_inventory_tracking':
    'Seguimiento de activos e inventario',
  'pricing.sh_feature_local_data_storage': 'Almacenamiento de datos local',
  'pricing.sh_plan_professional_name': 'Profesional',
  'pricing.sh_plan_professional_description':
    'Ideal para el cultivo de plantas que requieren listas de verificación avanzadas, flujos de trabajo y una integración más profunda del sistema.',
  'pricing.sh_feature_everything_in_basic_plus': 'Todo lo del plan Básico más:',
  'pricing.sh_feature_unlimited_assets_checklists':
    'Activos/Listas de verificación ilimitados',
  'pricing.sh_feature_nfc_barcode_scanning':
    'NFC y escaneo de códigos de barras',
  'pricing.sh_feature_email_support': 'Soporte por correo electrónico',
  'pricing.sh_plan_business_name': 'Negocio',
  'pricing.sh_plan_business_description':
    'Operaciones a gran escala que requieren gestión de múltiples instancias, marca personalizada y seguridad de primer nivel.',
  'pricing.sh_feature_everything_in_professional_plus':
    'Todo lo del plan Profesional más:',
  'pricing.sh_feature_multi_instance_management':
    'Gestión de múltiples instancias',
  'pricing.sh_feature_custom_user_roles': 'Roles de usuario personalizados',
  'pricing.sh_feature_priority_implementation_support':
    'Apoyo a la implementación prioritaria',
  'pricing.faq_free_users_q':
    '¿Qué tipos de usuarios se consideran usuarios gratuitos?',
  'pricing.faq_free_users_a1':
    'Hay tres tipos de usuarios que no requieren una licencia paga:',
  'pricing.faq_view_only_users_title': 'Ver solo usuarios',
  'pricing.faq_view_only_users_description':
    'Estos usuarios suelen ser supervisores que inician sesión con poca frecuencia para ver un resumen de la actividad de mantenimiento. También pueden enviar solicitudes de trabajo y generar informes.',
  'pricing.faq_requester_users_title': 'Usuarios solicitantes',
  'pricing.faq_requester_users_description':
    'Estos usuarios solo pueden enviar solicitudes de trabajo y ver su estado. No pueden ver órdenes de trabajo, activos, piezas ni ningún otro dato almacenado en el CMMS.',
  'pricing.faq_third_party_users_title': 'Usuarios de terceros',
  'pricing.faq_third_party_users_description':
    'Estos usuarios suelen ser proveedores y contratistas. No pueden iniciar sesión en el sistema. Solo pueden enviar actualizaciones a una orden de trabajo específica en la que están asignados a través de un enlace público.',
  'pricing.faq_paid_users_q':
    '¿Qué tipos de usuarios se consideran usuarios de pago?',
  'pricing.faq_paid_users_a1':
    'Hay tres tipos de usuarios que requieren una licencia paga:',
  'pricing.faq_admin_users_title': 'Usuarios administradores',
  'pricing.faq_admin_users_description':
    'Estos usuarios pueden agregar a otros a la cuenta, aceptar o rechazar solicitudes de trabajo y editar los detalles de las órdenes de trabajo. Son los usuarios que controlan la cuenta. Puede tener varios administradores por cuenta.',
  'pricing.faq_technical_users_title': 'Usuarios técnicos',
  'pricing.faq_technical_users_description':
    'Estos usuarios suelen ser técnicos que cierran órdenes de trabajo en campo. Pueden editar las órdenes de trabajo que crean, pero no otras. Pueden agregar imágenes y actualizaciones de estado a las órdenes de trabajo, así como crear nuevas.',
  'pricing.faq_limited_technical_users_title': 'Usuarios técnicos limitados',
  'pricing.faq_limited_technical_users_description':
    'Estos usuarios tienen los mismos privilegios que el usuario técnico. La única excepción es que solo pueden ver las órdenes de trabajo que les han sido asignadas, no las de otros usuarios técnicos de la cuenta.',
  'pricing.faq_change_plans_q': '¿Puedo cambiar de planes más adelante?',
  'pricing.faq_change_plans_a':
    'Sí, puedes cambiar a un plan superior o inferior en cualquier momento. Los cambios entran en vigor al inicio de tu próximo ciclo de facturación.',
  'pricing.faq_free_trial_q': '¿Hay una prueba gratuita?',
  'pricing.faq_free_trial_a':
    'Sí, ofrecemos una prueba gratuita de 15 días del plan Business para que pueda experimentar todas las funciones antes de tomar una decisión.',
  'pricing.faq_non_profit_discounts_q':
    '¿Ofrecen descuentos para organizaciones sin fines de lucro?',
  'pricing.faq_non_profit_discounts_a':
    'Sí, ofrecemos precios especiales para organizaciones sin fines de lucro. Para más información, contacte con nuestro equipo de ventas.',
  'pricing.faq_payment_methods_q': '¿Qué métodos de pago aceptan?',
  'pricing.faq_payment_methods_a':
    'Aceptamos todas las principales tarjetas de crédito, transferencias bancarias y PayPal. Para planes Enterprise, también gestionamos la facturación.',
  'pricing.faq_cancel_subscription_q': '¿Puedo cancelar mi suscripción?',
  'pricing.faq_cancel_subscription_a':
    'Sí, puedes cancelar tu suscripción en cualquier momento. Seguirás teniendo acceso hasta el final de tu periodo de facturación actual.',
  'pricing.faq_data_secure_q': '¿Están seguros mis datos?',
  'pricing.faq_data_secure_a':
    'Sí, nos tomamos muy en serio la seguridad de los datos. Todos los datos están cifrados, tanto en tránsito como en reposo, y realizamos auditorías de seguridad periódicas.',
  'pricing.faq_title': 'Preguntas frecuentes',
  'pricing.annually_save_two_months': 'Anualmente (Ahorra 2 meses)',
  'pricing.most_popular': 'Más populares',
  'pricing.get_your_license': 'Obtenga su licencia',
  get_started: 'Empezar',
  workflow_automation: 'Automatización del flujo de trabajo',
  push_notifications: 'Notificaciones push',
  cloud: 'Nube',
  self_hosted: 'Autoalojado',
  full: 'Lleno',
  pricing: 'Precios',
  industries: 'Industrias',
  work_order_management: 'Gestión de órdenes de trabajo',
  inventory_management: 'Gestión de inventarios',
  analytics_and_reporting: 'Análisis e informes',
  manufacturing: 'Fabricación',
  facility_management: 'Gestión de instalaciones',
  food_and_beverage: 'Alimentos y bebidas',
  healthcare: 'Salud',
  energy_and_utilities: 'Energía y servicios públicos',
  education: 'Educación',
  hospitality: 'Hostelería',
  construction: 'Construcción',
  installation_docs: 'Documentación de instalación'
};

export default esJSON;
